module.exports = "<app-acs></app-acs>\n<app-acs-out></app-acs-out>\n<app-nav></app-nav>\n\n<top-nav *ngIf=\"loggedIn\"></top-nav>\n\n<div class=\"container-fluid\">\n  <div class=\"row m-0\">\n    <div class=\"col\" *ngIf=\"loggedIn\" id=\"mainPage\">\n      <router-outlet></router-outlet>\n    </div>\n  </div>\n</div>\n\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main